module.exports = __webpack_public_path__ + "static/media/aestheteWeb.d6870f73.png";